// src/web/client/src/pages/Results.jsx
//
// Results — what the emails brought back (UX brief, Phase B3): Overview,
// Emails (per type), Revenue (orders that followed an email, and — on the
// Platform plan — repeat orders after a restock reminder) and Segments. The
// four were Analytics' own inner button row; now they are this page's one tab
// strip, and the hosted screen only renders the section it is told to.
//
// Sentiment is gone from here on purpose (B3 decision): the "sentiment" screen
// scored customers from order recency and spend — the same facts Customers
// shows as stage and risk — and called it sentiment; the one-customer drill-down
// ran a sentiment model over the emails WE wrote. Neither is the customer's
// sentiment, so neither is shown.

import React from 'react';
import PageTabs from '@/components/PageTabs';
import PageHeader from '@/components/PageHeader';
import { PlatformGate, PLATFORM_PAGES } from '@/pages/Platform';
import Analytics from '@/pages/Analytics';

export const RESULTS_SECTIONS = [
  { id: 'overview', label: 'Overview', tab: 'overview' },
  { id: 'emails', label: 'Emails', tab: 'messages' },
  { id: 'revenue', label: 'Revenue', tab: 'attribution' },
  { id: 'segments', label: 'Segments', tab: 'segments' },
];

export default function Results() {
  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        <PageHeader title="Results" subtitle="What your emails brought back" />
        <PageTabs param="section" tabs={RESULTS_SECTIONS.map((s) => ({
          id: s.id,
          label: s.label,
          render: () => (
            <div className="space-y-8">
              <Analytics embedded tab={s.tab} />
              {s.id === 'revenue' ? (
                <section className="space-y-3" data-testid="results-repeat-after-reminder">
                  <div>
                    <h2 className="text-lg font-semibold text-gray-900">Repeat orders after a restock reminder</h2>
                    <p className="text-sm text-gray-500">Orders placed after a customer received a restock reminder.</p>
                  </div>
                  <PlatformGate><PLATFORM_PAGES.revenue /></PlatformGate>
                </section>
              ) : null}
            </div>
          ),
        }))} />
      </div>
    </div>
  );
}
